/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoReleaseVoyageContainersInput = {
    clientMutationId?: string | null;
    voyageSlug?: string | null;
    containerReleaseInfo: Array<ContainerReleaseInfo>;
};
export type ContainerReleaseInfo = {
    containerSlug: string;
    pickupLocationSlug?: string | null;
    pickupReference?: string | null;
    pickupDate?: string | null;
    turninReference?: string | null;
    turninLocationSlug?: string | null;
    latestTurninDate?: string | null;
    latestPickupDate?: string | null;
};
export type VoyageContainerReleaseWizardReleaseContainerMutationVariables = {
    input: infoReleaseVoyageContainersInput;
};
export type VoyageContainerReleaseWizardReleaseContainerMutationResponse = {
    readonly infoReleaseVoyageContainers: {
        readonly clientMutationId: string | null;
    } | null;
};
export type VoyageContainerReleaseWizardReleaseContainerMutation = {
    readonly response: VoyageContainerReleaseWizardReleaseContainerMutationResponse;
    readonly variables: VoyageContainerReleaseWizardReleaseContainerMutationVariables;
};



/*
mutation VoyageContainerReleaseWizardReleaseContainerMutation(
  $input: infoReleaseVoyageContainersInput!
) {
  infoReleaseVoyageContainers(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoReleaseVoyageContainersPayload",
    "kind": "LinkedField",
    "name": "infoReleaseVoyageContainers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VoyageContainerReleaseWizardReleaseContainerMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VoyageContainerReleaseWizardReleaseContainerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9f4485dd1816526648f6aa4bacf35ab0",
    "id": null,
    "metadata": {},
    "name": "VoyageContainerReleaseWizardReleaseContainerMutation",
    "operationKind": "mutation",
    "text": "mutation VoyageContainerReleaseWizardReleaseContainerMutation(\n  $input: infoReleaseVoyageContainersInput!\n) {\n  infoReleaseVoyageContainers(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '83668fbbc374b30cd2478c29fed95cc2';
export default node;
